export default {
  signUp(data) {
    return axios.post('/newsletter/subscribe', data);
  }
};
